import styled from 'styled-components';

export const DropdownStyled = styled.div`
  .label {
    margin-bottom: 0.5rem;
    color: ${({ theme }) => theme.COLORS.BLUE_2};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
  }
  .input_dropdown {
    border: none;
    width: 100%;
    box-sizing: border-box;
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    border: 0.0625rem solid ${({ theme }) => theme.COLORS.GRAY_1};
    padding: 0.3125rem 1.25rem;
    color: ${({ theme }) => theme.COLORS.GRAY_2};
    height: 2.75rem;
    border-radius: 1rem;
    display: flex;
    align-items: center;
  }
  /* react-dropdown ใส่ arrowClassName ให้เฉพาะตอนที่ "ไม่ได้" ส่ง arrowClosed/arrowOpen เข้ามา
     เราส่งไอคอนเองทั้งคู่ คลาส .arrow_dropdown จึงไม่เคยเกาะกับ element ไหนเลย
     ต้องจัดตำแหน่งที่ .Dropdown-arrow-wrapper ซึ่งเป็นตัวที่มีอยู่จริงแทน */
  .Dropdown-control.input_dropdown {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    /* เว้นที่ให้ลูกศรที่ลอยอยู่ ข้อความยาว ๆ จะได้ไม่วิ่งไปทับ */
    padding-right: 2.75rem;
    /* ฟอนต์ไทยมีสระบน/วรรณยุกต์ กล่องบรรทัดจึงสูงกว่าตัวอักษรมาก
       ถ้าปล่อยเป็นค่าเริ่มต้น กล่องบรรทัดจะล้นพื้นที่ด้านในของ control
       แล้วข้อความจะดูเยื้องขึ้นเมื่อเทียบกับลูกศร */
    line-height: 1.4;
    .Dropdown-placeholder.is-selected {
      color: ${({ theme }) => theme.COLORS.BLUE_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
    }
    .arrow {
      display: flex;
      align-items: center;
      line-height: 0;
    }
    /* ยืดเต็มความสูงของ control แล้วจัดไอคอนกึ่งกลางข้างใน
       ไม่พึ่งความสูงของ wrapper เอง ซึ่งเปลี่ยนตามไอคอนและ line-height */
    .Dropdown-arrow-wrapper {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 1.25rem;
      display: flex;
      align-items: center;
      line-height: 0;
      pointer-events: none;
      svg {
        display: block;
      }
    }
  }
  .myPlaceholderClassName {
    color: ${({ theme }) => theme.COLORS.BLUE_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S13};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
  }
  .errors {
    margin-top: 2px;
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    color: ${({ theme }) => theme.COLORS.RED_1};
  }
  .Dropdown-menu {
    color: ${({ theme }) => theme.COLORS.BLUE_2};
    font-size: ${({ theme }) => theme.FONT.SIZE.S13};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
    background-color: ${({ theme }) => theme.COLORS.WHITE_1};
    border-radius: 5px;
    box-sizing: border-box;
    margin-top: 4px;
  }

  .theme_standard {
  }
`;
